// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__11mJv","itemTitle":"ClientEmergencyInfo_itemTitle__3380N","itemText":"ClientEmergencyInfo_itemText__wLI5j"};